import React from 'react';

import styles from './index.module.scss';

import { INavBar } from './../../models/index';

import { PlaceholderIconSvg } from '../svgs/PlaceholderIconSvg';
import BackIconSvg from '../svgs/BackIconSvg';

import { useNavigate } from 'react-router-dom';

import { useClickOutside } from '../../hooks/useClickOutside';
import { useCompleteCart } from '../../integrations/react_query/mutations';
import { getCurrentCart } from '../../integrations/react_query/queryFn';
import { getSessionInfo } from '../../utils/getSessionInfo';
import { logoutUser } from '../../utils/logoutUser';
import { captureException } from '../../integrations/sentry/capture';
import MenuIconSvg from '../svgs/MenuIconSvg';
import WeatherWidget from '../weather';
import { CartIcon } from './../resuable-ui/cart-icon/index';
import { OnlineIndicator } from './../resuable-ui/online-indicator';
import CartModal from '../resuable-ui/cart-modal/index';

const Navbar = ({ showBar, setNavState, navState }: INavBar) => {
	const navigate = useNavigate();

	const { userInfo } = getSessionInfo();

	const userRole = userInfo?.roles[0];

	const { mutateAsync } = useCompleteCart();

	const handleNavigateBack = async () => {
		try {
			const currentCart = await getCurrentCart();

			if (currentCart?.transactionId) {
				await mutateAsync('');
			}
			navigate('/terminal');
		} catch (err) {
			captureException(err, { fn: 'Navbar.handleNavigateBack' });
		}
	};

	const handleLogout = async () => {
		logoutUser();
	};

	const dropdownRef = React.useRef(null);

	const [showDropdown, setShowDropdown] = React.useState(false);
	const [showCartModal, setShowCartModal] = React.useState(false);

	useClickOutside({ ref: dropdownRef, callback: () => setShowDropdown(false) });

	return (
		<>
			<section
				className={`fixed md:relative top-0 left-0 right-0 z-50 flex align-items-center justify-content-between ${styles.wrapper} `}
			>
				{showBar ? (
					<div className="d-flex align-items-center">
						<aside className={`mt-2 ${styles.menu}`} onClick={() => setNavState(!navState)}>
							<MenuIconSvg />
						</aside>
						<aside className={`mt-2 mx-2 ${styles.icon}`}>
							<img alt="logo" width="100%" height="100%" src="/shoppa-icon.svg" />
						</aside>
					</div>
				) : (
					<div
						onClick={() => {
							handleNavigateBack();
						}}
						className={styles.cursor}
					>
						<BackIconSvg />
					</div>
				)}

				<WeatherWidget />

				<div className="hidden md:flex items-center">
					<div className={`${styles.grWrapper} mx-2`}>
						<aside className={`${styles.greeting}`}>
							<span>
								Hello,{' '}
								{userInfo?.profile?.firstName && userInfo?.profile?.lastName
									? `${userInfo?.profile?.firstName} ${userInfo?.profile?.lastName}`
									: userInfo?.profile?.email}
							</span>
						</aside>
						<aside className={`${styles.position}`}>
							<span>{userInfo?.profile?.jobTitle || userRole}</span>
						</aside>
					</div>

					<div
						className="position-relative"
						onClick={() => {
							setShowDropdown(!showDropdown);
						}}
					>
						<PlaceholderIconSvg width="40" height="40" viewBox="0 0 50 50" />
					</div>
				</div>

				<div className="flex md:hidden items-center gap-3">
					<div>
						<OnlineIndicator />
					</div>
					<CartIcon onClick={() => setShowCartModal(true)} />
				</div>

				{showDropdown && (
					<div
						ref={dropdownRef}
						className={`position-absolute shadow-sm ${styles.dropDown} px-4 mt-1 rounded`}
						style={{ right: '3em', top: '3.5em', zIndex: 100 }}
					>
						<div className={`${styles.dropDownList} py-2`} onClick={handleLogout}>
							Logout
						</div>
					</div>
				)}
			</section>

			<div className="flex md:hidden">
				<CartModal show={showCartModal} onClose={() => setShowCartModal(false)} />
			</div>
		</>
	);
};

export default React.memo(Navbar);
